class RuleGeneratorService {
  async getAssetTypes() {
    const tokenStr = sessionStorage.getItem("token");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/asset_types`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${tokenStr}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (err) {
      console.error("Error in getAssetTypes:", err);
      throw err;
    }
  }

  async getComponentTypes() {
    const tokenStr = sessionStorage.getItem("token");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/component_types`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${tokenStr}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const componentData = await response.json();
      return componentData;
    } catch (err) {
      console.error("Error in getComponentTypes:", err);
      throw err;
    }
  }

  async getAssetTypeRules(assetType: string) {
    if (!assetType) return "";
    const tokenStr = sessionStorage.getItem("token");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/rules/${assetType}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${tokenStr}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const yamlText = await response.text();
      return yamlText;
    } catch (err: any) {
      console.log(err);
      throw err;
    }
  }

  async updateAssetTypeRules(assetType: string, yamlContent: string) {
    const tokenStr = sessionStorage.getItem("token");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/rules/${assetType}`,
        {
          method: "POST",
          body: yamlContent,
          headers: {
            Authorization: `Bearer ${tokenStr}`,
            "Content-Type": "application/yaml; charset=utf-8",
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.text();
      return data;
    } catch (err) {
      console.log("Error Asset Post: ", err);
      throw err;
    }
  }

  async getAssetsByAssetType(assetType: string) {
    if (!assetType) return { assets: [], count: 0 };
    const tokenStr = sessionStorage.getItem("token");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/asset_types/${assetType}/assets`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${tokenStr}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (err) {
      console.error("Error in getAssetsByAssetType:", err);
      return { assets: [], count: 0 };
    }
  }

}

export default new RuleGeneratorService();